export const dwStatusListJson = [
  {
    'status': '400',
    'desc': '錯誤的請求'
  },
  {
    'status': '401',
    'desc': '發送的請求缺乏憑證'
  },
  {
    'status': '403',
    'desc': '抱歉，您無權訪問該頁面'
  },
  {
    'status': '404',
    'desc': '抱歉，您訪問的頁面不存在'
  },
  {
    'status': '500',
    'desc': '抱歉，服務器出錯了'
  }
];
